Vue.component('breadcrumbs', {
  template: '#vue-breadcrumbs',
	props: {
	  breadcrumbs: {
      type: Array,
      default: function () { return [] }
    },
	  breadcrumbNow: { 
      default: '' 
    }
	},
	data: function () {
		return {
      homeHref: '',
      breadcrumbsHrefs: {},
      breadcrumbNowHref: ''
		}
  },
  watch: {
    'breadcrumbs': function (newType, oldType) {
      if (oldType != '') {
        this.changedBreadcrumbs();
      }
    }
  },
  methods: {
    changedBreadcrumbs: function () {
      const self = this;
      for (let key in self.breadcrumbs) {  
        if (self.breadcrumbs[key].text && self.breadcrumbs[key].routeName) {
          self.breadcrumbsHrefs[key] = 'https://'+ location.host + self.$router.resolve({name: self.breadcrumbs[key].routeName, params: self.breadcrumbs[key].params}).href;
        }
      }
      if (self.breadcrumbNow) self.breadcrumbNowHref = location.protocol + '//' + location.host + location.pathname;
    }
  },
	created: function () {
    this.homeHref = 'https://'+ location.host; //window.location.hostname
    this.changedBreadcrumbs();
  }
});

Vue.component('breadcrumbs-now', {
  template: '#vue-breadcrumbs-now',
	props: {
    breadcrumbNow: { 
      default: '' 
    },
	  breadcrumbNowHref: {
      default: ''
    },
	  metaPosition: {
      default: '2'
    }
	}
});
